// src/components/RequireTrialActive.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import API_BASE from '../apiConfig';

function RequireTrialActive({ children }) {
  const [status, setStatus] = useState({ loading: true, expired: false });

  useEffect(() => {
    let cancelled = false;

    async function checkTrial() {
      try {
        const res = await fetch(`${API_BASE}/trial-status`, {
          credentials: 'include',
        });

        if (!res.ok) {
          // Om vi inte får svar → släpp igenom så appen funkar
          if (!cancelled) setStatus({ loading: false, expired: false });
          return;
        }

        const json = await res.json();

        if (!cancelled) {
          setStatus({
            loading: false,
            // ✅ använd värdet från backend igen
            expired: Boolean(json.trialExpired),
          });
        }
      } catch (e) {
        console.error('trial-status error:', e);
        if (!cancelled) setStatus({ loading: false, expired: false });
      }
    }

    checkTrial();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status.loading) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        Kontrollerar din testperiod…
      </div>
    );
  }

  if (status.expired) {
    return <Navigate to="/trial-expired" replace />;
  }

  return children;
}

export default RequireTrialActive;
